export const getCampaignQuery = `
query FetchCampaign {
  Campaign {
    all(active: true, campaignTypeSlugs: ["product_campaign", "plan_campaign"]) {
      items {
        id
        campaignName
        discountCouponId
        discountCoupon {
          active
          name
          couponcode
          value
          validuntil
          cycles
          datecreated
          discountcoupontype {
            internalname
          }
        }
      }
    }
  }
}
`;
